import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalEntityCompiler from '../../../components/Modals/ModalEntityCompiler';
import { toast } from 'react-toastify';



export default function DGLTH_customer_transport_document({ item, entity = null, refreshData }) {

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);



    function openModal() {
        setShowModal(true)
    }
    function closeModal() {
        setShowModal(false)
    }


    useEffect(() => {
        console.log(item)
    }, [])

    async function createInvoiceFromBackend() {
        setShowModal(true);

        try {
            const body = {
                id: item.id
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/create_invoice_from_transport_document', body);

            if (response.success === 1) {
                toast.success('Fattura accompagnatoria creata con successo!', { theme: 'colored' });
                setShowModal(false);
                if (refreshData) {
                    refreshData();
                }
            } else {
                toast.error(response.message || 'Errore nella creazione della fattura!', { theme: 'colored' });
                setShowModal(false);
            }
        } catch (error) {
            console.error('Errore nella creazione della fattura:', error);
            toast.error('Errore nella creazione della fattura!', { theme: 'colored' });
            setShowModal(false);
        }
    }

    async function createDDTFromBackend() {
        setShowModal(true);

        try {
            const body = {
                id: item.id
            };

            const response = await ApiManager.sendAuthenticatedRequest('/custom/create_ddt_from_transport_document', body);

            if (response.success === 1) {
                toast.success('DDT creato con successo!', { theme: 'colored' });
                setShowModal(false);
                if (refreshData) {
                    refreshData();
                }
            } else {
                toast.error(response.message || 'Errore nella creazione del DDT!', { theme: 'colored' });
                setShowModal(false);
            }
        } catch (error) {
            console.error('Errore nella creazione del DDT:', error);
            toast.error('Errore nella creazione del DDT!', { theme: 'colored' });
            setShowModal(false);
        }
    }

    return (
        <>
            {item ? (
                <>
                    {
                        item.status.value === '0_PENDING' && item.unloadDDT === 1 ?
                            <>
                                <Button size='sm' variant='outline-secondary' className='me-2' onClick={() => { createDDTFromBackend() }}>Crea DDT</Button>
                            </>
                            : null
                    }
                    {
                        item.status.value === '0_PENDING' && item.unloadDDT === 0 ?
                            <>
                                <Button size='sm' variant='outline-secondary' className='me-2' onClick={() => { createInvoiceFromBackend() }}>Crea Fattura Acc.</Button>
                                <Button size='sm' variant='outline-secondary' className='me-2' onClick={() => { createDDTFromBackend() }}>Crea DDT</Button>
                            </>
                            : null
                    }


                    <Modal show={showModal} onHide={closeModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Generazione documenti</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div className='text-center p-3'>
                            <Spinner animation="border" variant="primary" />
                            <p className='text-primary'>Generazione in corso...</p>
                        </div></Modal.Body>
                    </Modal>
                </>
            ) : (
                <></>
            )}
        </>
    )
};
